export const safetyManager = {
  on_test__hydrogen_monitoring: {
    dependencyField: "pool",
    dependencyFieldConditions: ["h2 sensing"],
  },
};

export const dependantFieldsToManage = Object.keys(safetyManager);
